<template>
  <div class="base-plans">
    <template v-if="!loading">
      <BasePlanCard
        class="plan"
        :title="plan.title"
        :price="plan.price"
        :interval="plan.interval"
        :features="plan.features"
        :disabled="plan.name === subscribedPlanName || (selected && selected !== plan.name)"
        :cta="
          (() => {
            if (plan.name === subscribedPlanName) return 'Current plan'
            if (plan.trialDays > totalDaysSubscribed) return 'Try it free'
            else return 'Get started'
          })()
        "
        @selected="handleSelected(plan)"
        v-for="(plan, i) in plans"
        :key="`plan-${i}`"
      />
      <BaseFiller class="filler" v-for="n in !(plans.length % 3) || 3 - (plans.length % 3)" :key="`filler-${n}`" />
    </template>
    <BaseContentLoader class="loader" v-else />
  </div>
</template>

<script>
import BaseFiller from '@/components/BaseFiller/BaseFiller'
import BasePlanCard from '@/components/BasePlanCard/BasePlanCard'
import BaseContentLoader from '@/components/BaseContentLoader/BaseContentLoader'
import subscriptionService from '@/services/api/services/subscriptionService'
export default {
  components: {
    BaseFiller,
    BasePlanCard,
    BaseContentLoader
  },
  async created() {
    this.plans = await subscriptionService.findAllPlans()
    this.loading = false
  },
  data: () => ({
    loading: true,
    selected: null,
    plans: []
  }),
  computed: {
    totalDaysSubscribed() {
      return this.$store.state.user.totalTimeSubscribed
    },
    subscribedPlanName() {
      const subscribedPlan = this.plans.find(plan => plan.subscribed === true)
      return subscribedPlan && subscribedPlan.name
    }
  },
  methods: {
    async handleSelected(plan) {
      this.selected = plan.name
      const confirmationUrl = await subscriptionService.create({ name: plan.name })
      if (confirmationUrl) {
        this.$shopify.redirectToExternalUrl(confirmationUrl)
        await new Promise(() => {})
      } else {
        await this.$store.dispatch('authenticate')
        this.$router.push('/widget')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-plans {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: var(--spacing-5);
  @include media(sm-down) {
    grid-auto-flow: row;
    grid-template-columns: auto;
  }
}
.loader {
  grid-column: 1 / 4;
}
.filler {
  @include media(sm-down) {
    display: none;
  }
}
</style>
